<template>
    <nut-popup v-model:visible="visible"  :close-on-click-overlay="true" style="background-color: transparent">
        <div class="dialog-content">
            <div class="content-box showMoney">
                <div class="desc">
                    <div class="content">
                        <div class="text">当前可提取金额</div>
                        <div class="count">{{hongbao_info.data.amount}}<span>元</span></div>
                    </div>
                    <div class="tixian-box">
                        <TxButton src="anniu_2" class="t-btn" name="直接提现" @click="getHongbao">
                            <span>直接提现</span>
                        </TxButton>
                    </div>
                </div>
            </div>
        </div>
    </nut-popup>
</template>

<script lang="ts" setup>
import { ref, inject } from 'vue';
import useWeChatEnv from '@/plugins/vue/useWeChatOrMiniProgram';
import eventEmitter from '@utils/event';
import { claim_appoint_money } from '@utils/api';
import { showToast } from '@nutui/nutui'
import Storage from '@/utils/storage'
const GlobalReporter = inject('GlobalReporter');

const { isWeChat, isMiniProgram } = useWeChatEnv();
const { init_data } = inject('GlobalData');
const { canReveive, reveiveDataFormat } = inject('GlobalStore');
const hongbao_info=ref(null)

eventEmitter.on('showHongbaoModal', (data) => {
    GlobalReporter.add({ btn_name: '点击红包' });
    hongbao_info.value=data
    visible.value = true
});
const ACTIVITY_ID = import.meta.env.VITE_NAME;
const visible = ref(false)
const loading = ref(false)
const storageClassIns = ref(new Storage())

function closeModal() {
    visible.value = false
}

function beforeReceive() {
    if (!(isWeChat.value || isMiniProgram.value)) {
        eventEmitter.emit('showCommomTipModal', 'openInwx');
        return false
    }
    if (!init_data.act_data.magic_unionid) {
        eventEmitter.emit('showCommomTipModal', 'mofangAuth');
        return false
    }
    return true
}

function getHongbao() {
    if(hongbao_info.value.data.amount<=0){
        // eventEmitter.emit('toast', {
        //         text: '金额不足，无法提现',
        //     });
            return 
    }

    const ispass = beforeReceive()
    if (!ispass) return
    if (loading.value) return
    loading.value = true
    const loadingToast = showToast.loading('领取中...', {
        cover: true,
        duration: 0
    })
    claim_appoint_money().then(res => {
        loadingToast && loadingToast.hide()
        loading.value = false
        if (res.code !== 1) {
            eventEmitter.emit('toast', {
                text: res.errorMsg,
            });
            return
        }
        eventEmitter.emit('toast', {
            text: '领取成功, 请稍后前往微信查看',
        });
    })
}
</script>

<style lang="scss" scoped>
.dialog-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 24px;

    .content-box {
        &.close {
            @include bg('hongbao');

            .desc {
                position: relative;
                width: 100%;
                height: 100%;

                .limit-box {
                    position: absolute;
                    bottom: 50px;
                    width: 100%;
                    text-align: center;
                    color: #fff;
                }
            }
        }

        &.showMoney {
            @include bg('hongbaotiqu');

            .tip {
                margin-top: 60px;
            }

            .limit-box {
                color: #fff;
                margin-top: 15px;
            }
        }

        .desc {
            display: flex;
            flex-direction: column;
            align-items: center;

            .content {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                height: 700px;
                // background-color: #acf;
                margin-bottom: 40px;

                .text {
                    color: #6c2e34;
                    font-size: 32px;
                }

                .count {
                    color: #6b2a33;
                    font-size: 88px;

                    span {
                        font-size: 36px;
                    }
                }
            }

            .small {
                font-size: 24px;
                color: #fff;
            }
        }
    }

    .close-box {
        width: 100%;
        height: 100px;
        display: flex;
        justify-content: center;
        align-items: center;

        .close-icon {
            color: #fff;
        }
    }

    .group-btn {
        margin-top: 0px;
    }

    .tixian-box {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        top:20px;

        .tixian-tip {
            text-align: center;
            font-size: 22px;
            color: #fff;
            line-height: 28px;
        }
    }

}
</style>